/*
  Bellary — Einblenden beim Scrollen (Runde 36b, 27.8.2026)

  Keine Bibliothek, keine Abhängigkeit, kein Modul. Reine CSS-Übergänge, die
  ein IntersectionObserver auslöst. Dauern, Kurven und Bewegungsweg stehen
  ALLE in snippets/bellary-store-styles.liquid — hier wird nichts davon
  dupliziert, nur `--reveal-stagger` ausgelesen.

  ⚠️⚠️ WARUM ÜBERGANG UND NICHT `animation`:
  Ein `transform` ungleich `none` macht das Element zum Bezugsrahmen für
  `position: fixed` seiner Nachfahren. Chrome behält bei `animation-fill-mode`
  am Ende NICHT das Schlüsselwort `none`, sondern die Einheitsmatrix — der
  Bezugsrahmen bliebe also für immer bestehen. Genau daran ist die
  Countdown-Seite schon einmal gescheitert. Ein Übergang auf `transform: none`
  hinterlässt dagegen einen echten `none`-Wert.

  ⚠️ Zusätzlich live nachgesehen (27.8.2026): auf der Produktseite liegen
  `.sticky-add-to-cart__bar` (fixed), `media-gallery` und `.product-details`
  (sticky) INNERHALB einer Sektion. Dafür die Tabu-Liste und die KLEBT-Prüfung.

  ⚠️⚠️ ZUSAMMENSPIEL MIT DEM CSS — die Reihenfolge ist der ganze Trick:
  1. Ein Inline-Schnipsel im Kopf setzt `html.bellary-bewegung`, sofern der
     Besucher Bewegung nicht abbestellt hat. Das passiert VOR dem ersten
     Bildaufbau.
  2. Das CSS blendet daraufhin die unten aufgelisteten Elemente auf
     `opacity: 0` — ohne Übergang. Deshalb flackert nichts.
  3. Diese Datei verteilt `data-reveal` auf die Elemente, die wirklich
     animiert werden, und NIMMT `html.bellary-bewegung` danach wieder weg.
     Alles, was übersprungen wurde, ist damit sofort sichtbar.
  4. Fällt diese Datei aus, nimmt eine Zeitschaltung im Inline-Schnipsel die
     Klasse nach 2 s trotzdem weg. Es kann also nichts dauerhaft unsichtbar
     bleiben — auch nicht bei einem Fehler.
  ⚠️ Die Auswahllisten unten und die im CSS müssen deckungsgleich bleiben.
*/
(function () {
  'use strict';

  var wurzel = document.documentElement;

  function freigeben() {
    wurzel.classList.remove('bellary-bewegung');
  }

  /* ⚠️ RUNDE 42: Das Ankündigungsband wechselt seit dieser Runde von selbst
     alle 5 Sekunden. Horizons announcement-bar.js pausiert zwar bei :hover
     und im Hintergrundtab, kennt aber KEINE Bewegungsreduktion — in
     assets/announcement-bar.js nachgesehen.
     Selbstlaufender Inhalt ohne Stoppmöglichkeit ist genau der Fall, den
     WCAG 2.2.2 meint. Wer Bewegung abbestellt hat, bekommt deshalb keinen
     Wechsel: das autoplay-Attribut fällt weg, die erste Zeile bleibt stehen.
     Die Pfeile bleiben bedienbar, es ist also weiter alles erreichbar.
     ⚠️ Muss VOR den Ausstiegen darunter laufen — bei reduzierter Bewegung
     wird die Vorbereitungsklasse gar nicht erst gesetzt, das Skript stiege
     also aus, bevor es hier ankäme. */
  if (!wurzel.classList.contains('bellary-bewegung')) {
    [].slice.call(document.querySelectorAll('announcement-bar-component[autoplay]'))
      .forEach(function (el) {
        el.removeAttribute('autoplay');
        if (typeof el.pause === 'function') el.pause();
      });
  }

  var haupt = document.getElementById('MainContent');
  if (!haupt || !('IntersectionObserver' in window)) return freigeben();
  if (!wurzel.classList.contains('bellary-bewegung')) return;

  /* Reihenweise gestaffelt */
  var GESTAFFELT = [
    '#MainContent .resource-list__item',
    '#MainContent ul.product-grid > li',
    '#MainContent .bellary-editorial-kachel',
    /* ⚠️ Runde 44: die einzelnen Galeriekacheln der Produktseite — NICHT
       `media-gallery` selbst. Das Element ist `position: sticky`, und ein
       transform auf ihm oder einem seiner Vorfahren würde das Kleben
       zerstören (dieselbe Falle wie bei .shopify-section). Ein transform auf
       NACHFAHREN eines klebenden Elements ist dagegen unbedenklich.
       `media-gallery` steht deshalb weiter in der Tabu-Liste. */
    '#MainContent media-gallery .media-gallery__grid > *'
  ].join(',');

  /* Einzeln, ohne Staffelung */
  var EINZELN = [
    '#MainContent h1',
    '#MainContent h2',
    '#MainContent .bellary-promo-karte',
    '#MainContent .bellary-promo-bild-wrap',
    '#MainContent a.button-unstyled'
  ].join(',');

  /* ⚠️ Nichts davon wird je animiert: alles, was zur Kaufentscheidung gehört,
     ist sofort da. Formulare und Fehlermeldungen ebenso. */
  var TABU = [
    '.product-information',
    '.product-details',
    'media-gallery',
    '.sticky-add-to-cart',
    '.product-card',
    '.resource-list__slide',
    '.price',
    '.cart-drawer',
    'form',
    'dialog',
    /* ⚠️ Runde 36: Rechtstexte werden nie animiert. Impressum, AGB,
       Datenschutzerklaerung und Widerrufsbelehrung rendert Shopify in
       `.shopify-policy__container`. Wer eine Widerrufsbelehrung sucht, soll
       sie lesen koennen, nicht auf ihr Einblenden warten — und eine
       Pflichtangabe, die erst beim Scrollen erscheint, ist im Streitfall
       schwer zu verteidigen. */
    '.shopify-policy__container',
    /* ⚠️ Runde 38: Das Instagram-Laufband bewegt sich schon von selbst. Ein
       Einblenden beim Scrollen waere eine zweite Bewegung ueber der ersten
       und wirkt unruhig. Ausserdem setzt das Reveal ein `transform` auf den
       Vorfahren — das wuerde mit der Laufanimation der Spur kollidieren. */
    '.bellary-ig-band'
  ].join(',');

  /* Elemente, die kleben und deshalb keinen transformierten Vorfahren dulden */
  var KLEBT = '.sticky-add-to-cart__bar, media-gallery, .product-details, .dialog-thumbnails-list-container, dialog';

  var SCHRITT = parseFloat(getComputedStyle(wurzel).getPropertyValue('--reveal-stagger')) || 100;
  var MAX_SCHRITTE = 4; /* nie länger als 4 x 100 ms warten, auch bei 20 Produkten */
  var HERO_START = 500; /* bei Hill House gemessen */
  var AUFRAEUMEN = 700; /* --dur-base plus Puffer */

  function ungeeignet(el) {
    if (el.hasAttribute('data-reveal') || el.dataset.revealFertig) return true;
    if (el.closest(TABU)) return true;
    if (el.getBoundingClientRect().width === 0) return true; /* Slider-Klone */
    if (el.matches(KLEBT) || el.querySelector(KLEBT)) return true;
    return false;
  }

  /* ⚠️⚠️ SELBSTPRÜFENDE RÜCKFALLTÜR — der wichtigste Teil dieser Datei.

     Live nachgemessen am 27.8.2026: In einem Tab mit
     `document.visibilityState === 'hidden'` liefert ein IntersectionObserver
     ÜBERHAUPT KEINEN Rückruf — genauso wenig wie requestAnimationFrame. Die
     Rückrufe hängen am Rendering-Schritt, und den überspringt der Browser
     dort. Ich habe die Seite in dem Zustand abfotografiert: das Produktraster
     war eine leere Fläche.

     Die Vorbereitungsklasse hilft dagegen NICHT, denn `data-reveal` verbirgt
     unabhängig von ihr. Deshalb hier eine zweite, andere Sicherung:

     Ein Beobachter meldet nach dem Start IMMER für jedes beobachtete Element
     einen Rückruf — auch für die, die gerade nicht im Bild sind. Bleibt der
     also ganz aus, arbeitet der Mechanismus nicht, und dann ist sofort alles
     sichtbar zu machen. Kein Effekt ist schlecht; eine leere Seite ist
     schlimmer.

     ⚠️ Auf `isIntersecting` darf dabei NICHT geprüft werden — sonst würde
     eine lange Seite, bei der anfangs nichts im Bild ist, fälschlich als
     "Beobachter kaputt" gelten und den Effekt abschalten. */
  var beobachterMeldetSich = false;

  var notausgangGefeuert = false;

  var notausgang = setTimeout(function () {
    if (beobachterMeldetSich) return;
    notausgangGefeuert = true;
    [].slice.call(document.querySelectorAll('[data-reveal]')).forEach(function (el) {
      beobachter.unobserve(el);
      el.removeAttribute('data-reveal');
      el.style.removeProperty('--reveal-delay');
      el.dataset.revealFertig = '1';
    });
  }, 1500);

  var beobachter = new IntersectionObserver(function (eintraege) {
    if (!beobachterMeldetSich) {
      beobachterMeldetSich = true;
      clearTimeout(notausgang);
    }
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      beobachter.unobserve(el);
      el.classList.add('is-revealed');
      /* ⚠️ Aufräumen: Attribut, Klasse und Verzögerung wieder weg, sobald der
         Übergang durch ist. Bliebe die Verzögerung kleben, würde sie später
         jeden Hover-Übergang auf demselben Element ausbremsen. Ohne Attribut
         greift die Regel nicht mehr — das Element steht dann auf seinen
         normalen Werten, also sichtbar. */
      aufraeumenNach(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

  function aufraeumenNach(el) {
    var wartet = parseFloat(el.style.getPropertyValue('--reveal-delay')) || 0;
    setTimeout(function () {
      el.removeAttribute('data-reveal');
      el.classList.remove('is-revealed');
      el.style.removeProperty('--reveal-delay');
      el.dataset.revealFertig = '1';
    }, wartet + AUFRAEUMEN);
  }

  function vormerken(el, verzoegerungMs) {
    /* ⚠️ Hat die Rückfalltür schon ausgelöst, arbeitet der Beobachter nicht.
       Dann darf auch nichts mehr verborgen werden — sonst würden Karten, die
       Horizon später nachrendert (Filter, Sortierung), unsichtbar hängen
       bleiben, weil die Rückfalltür nur ein einziges Mal läuft. */
    if (notausgangGefeuert) {
      el.dataset.revealFertig = '1';
      return;
    }
    if (verzoegerungMs) el.style.setProperty('--reveal-delay', verzoegerungMs + 'ms');
    el.setAttribute('data-reveal', '');
    beobachter.observe(el);
  }

  /* ⚠️ Das Hero ist ein AUFBAU-Effekt, kein Scroll-Effekt — deshalb laeuft es
     bewusst am Beobachter vorbei.
     Live gemessen: der Aufruf sitzt am unteren Bildrand des bildschirmhohen
     Heros (Oberkante 898 px bei 904 px Fensterhoehe). Der rootMargin von
     -10 % schneidet genau dort ab, der Beobachter haelt ihn also fuer
     ausserhalb — er waere erst beim Scrollen erschienen, und beim
     Zurueckscrollen nach oben nie. */
  function sofortEinblenden(el, verzoegerungMs) {
    if (verzoegerungMs) el.style.setProperty('--reveal-delay', verzoegerungMs + 'ms');
    el.setAttribute('data-reveal', '');
    /* ⚠️ KEIN requestAnimationFrame hier. In einem Hintergrundtab feuert rAF
       gar nicht — live nachgemessen: bei document.visibilityState === 'hidden'
       kam der Rückruf auch nach 900 ms nicht. Der Hero-Knopf wäre dann auf
       opacity 0 stehengeblieben, bis jemand den Tab nach vorn holt.
       Das Auslesen von offsetWidth erzwingt stattdessen einen Umbruch: der
       Startzustand ist damit sicher berechnet, und der Klassenwechsel in der
       Zeile darunter läuft als echter Übergang — unabhängig davon, ob der Tab
       im Vordergrund steht. */
    void el.offsetWidth;
    el.classList.add('is-revealed');
    aufraeumenNach(el);
  }

  function einsammeln() {
    /* Gestaffelte zuerst, damit die Einzel-Auswahl sie überspringen kann —
       eine Überschrift IN einer Karte darf nicht ein zweites Mal einblenden. */
    var karten = [].slice.call(document.querySelectorAll(GESTAFFELT)).filter(function (el) {
      return !ungeeignet(el);
    });

    /* Reihen über die Oberkante bilden. Das funktioniert unabhängig davon, ob
       das Raster ein grid oder ein flex ist, und fängt pro Reihe wieder bei 0
       an — deshalb wartet auch bei 20 Produkten niemand länger als 400 ms. */
    var reihen = {};
    karten.forEach(function (el) {
      var oben = Math.round(el.getBoundingClientRect().top / 8) * 8;
      (reihen[oben] = reihen[oben] || []).push(el);
    });
    Object.keys(reihen).forEach(function (schluessel) {
      reihen[schluessel].forEach(function (el, i) {
        vormerken(el, Math.min(i, MAX_SCHRITTE) * SCHRITT);
      });
    });

    [].slice.call(document.querySelectorAll(EINZELN)).forEach(function (el) {
      if (ungeeignet(el) || el.closest(GESTAFFELT)) return;
      /* Das Hero steht beim Aufbau schon im Bild. Der Aufruf blendet nach
         einer halben Sekunde ein — das Staffelmuster von Hill House. */
      if (el.closest('.hero')) sofortEinblenden(el, HERO_START);
      else vormerken(el, 0);
    });
  }

  einsammeln();
  freigeben();

  /* Horizon rendert das Produktraster beim Filtern und Sortieren neu
     (section-renderer.js). Ein passendes Theme-Event gibt es nicht — in
     assets/events.js nachgesehen —, deshalb dieser kleine Nachzügler.
     ⚠️ Ab hier ist `bellary-bewegung` weg, neue Karten bekommen ihren
     Startzustand also über `[data-reveal]` statt über die Vorbereitungsklasse. */
  var geplant = false;
  new MutationObserver(function (aenderungen) {
    if (geplant) return;
    if (!aenderungen.some(function (a) { return a.addedNodes.length > 0; })) return;
    geplant = true;
    /* Auch hier bewusst ein Timer statt rAF — im Hintergrundtab feuert rAF
       nicht, und dann bekämen nachgeladene Karten nie ihren Startzustand. */
    setTimeout(function () {
      geplant = false;
      einsammeln();
    }, 50);
  }).observe(haupt, { childList: true, subtree: true });
})();
